import { Transform, Type } from 'class-transformer';
import { IsEmail } from 'class-validator';
import { UserProfile } from './UserProfile';

export class UserEntity {
    id?: string;

    @IsEmail()
    username: string;

    @Transform(obj => obj.value)
    organization?: string | any = {};

    roles: string[] = [];

    isActive?: boolean;

    @Type(() => UserProfile)
    profile: UserProfile = new UserProfile();
}
